var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 5,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.77182 12.8957C8.45936 13.3198 7.97279 13.5804 7.44669 13.6063C6.92059 13.6325 6.41105 13.4204 6.05853 13.0289L2.89953 9.5233C2.39747 8.96649 2.44207 8.10817 2.99888 7.60611C3.55622 7.10404 4.414 7.14891 4.91607 7.70599L7.15106 10.1864C7.18417 10.2233 7.23224 10.243 7.28165 10.2406C7.33132 10.2382 7.37672 10.2134 7.40636 10.1738L12.0003 3.94317C12.4449 3.33963 13.2947 3.21117 13.8985 3.65609C14.5018 4.101 14.63 4.95077 14.185 5.55405L8.77182 12.8957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 11.9,
    height: 11.9,
    fill: "white",
    transform: "translate(2.55029 2.55005)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxActive);
export default __webpack_public_path__ + "static/media/checkBoxActive.23b98317.svg";
export { ForwardRef as ReactComponent };